module.exports = __webpack_public_path__ + "static/media/layout-2.7a81bafa.svg";